export const Services = {
   "PUBLIC_ACCESS": {
      "path": "https://oblapipublicaccess.azurewebsites.net/",
      "method": "GET",
      "descrp": "service"
   },
   "TRACEABILITY": {
      "path": "https://oblapishipments.azurewebsites.net/",
      "method": "GET",
      "descrp": "service"
   }
}